import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'
import linkifyHtml from 'linkifyjs/html'

Vue.directive('uppercase', {
    bind(el, _, vnode) {
        el.addEventListener('keyup', (e) => {
            e.target.value = e.target.value.toUpperCase()
            vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
        })
    }
})

Vue.directive('linkify', {
    bind(el, _, vnode) {
        el.innerHTML = linkifiedHtml(el.innerHTML)
    },
    componentUpdated(el, binding, vNode) {
        const newEl = el
        newEl.textContent = vNode.children[0].text || ''
        newEl.innerHTML = linkifiedHtml(newEl.textContent)
    }
})

function linkifiedHtml(text) {
    return linkifyHtml(text, {
        defaultProtocol: 'https',
        target: '_blank'
    })
}

Vue.directive('on-visible', {
    bind(el, { arg }, vnode) {
        el.inViewport = false
    },
    inserted(el, { arg }, vnode) {
        el.observer = new IntersectionObserver(
            (entries) => {
                if (!el.inViewport && entries[0].isIntersecting) {
                    vnode.context.$emit('visible')
                    el.inViewport = true
                } else if (el.inViewport) {
                    el.inViewport = false
                    vnode.context.$emit('invisible')
                }
            },
            {
                root: arg,
                threshold: '0'
            }
        )
        el.observer.observe(el)
    },
    unbind(el, _, vnode) {
        el.observer.disconnect()
        delete el.observer
        delete el.inViewport
    }
})

Vue.directive('mask', VueMaskDirective)

Vue.directive('work-in-progress', {
    inserted: function (el, binding) {
        const underConstructionComponent = new Vue({
            render: (h) => {
                return h('vx-work-in-progress', { props: binding.value })
            }
        }).$mount()

        el.appendChild(underConstructionComponent.$el)
    }
})
